import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import { CompanyEntity } from 'types/CompanyEntity'
import CompanyHistoryList from './history/CompanyHistoryList'
import { useLoaderData } from 'react-router-dom'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import ConvertiblesApi from '../../../api/ConvertiblesApi'
import { useQuery } from '../../../hooks/useQuery'
import { TradesGraph } from './trades-graph'
import { CurrentTransactions } from './CurrentTransctions/CurrentTransactions'
import { SHARE_SELECT_ROUTING_PARAM } from './CompanyShare'

const convertiblesApi = new ConvertiblesApi()

function CompanyDetailsView() {
    const [convertibles, setConvertibles] = useState<ConvertibleEntity[] | null>(null)
    const query = useQuery()

    const company = useLoaderData() as CompanyEntity

    const selectedShare =
        company?.shares.find((i) => i.id === query.get(SHARE_SELECT_ROUTING_PARAM)) || company?.shares?.[0]

    useEffect(() => {
        if (!company) return

        const fetchData = async () => {
            try {
                const fetchedConvertibles = await convertiblesApi.findByCompanyId(company.id)

                setConvertibles(fetchedConvertibles)
            } catch (e) {
                console.error(e)
            }
        }
        void fetchData()
    }, [company])

    return (
        <Grid container spacing={6}>
            <Grid size={{ xs: 12 }}>
                {selectedShare && (
                    <TradesGraph
                        companyId={company.id}
                        instrumentId={selectedShare.instrumentId}
                        instrumentName={selectedShare.symbol}
                    />
                )}
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
                <CurrentTransactions convertibles={convertibles || []} />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
                <CompanyHistoryList convertibles={convertibles} />
            </Grid>
        </Grid>
    )
}

export default CompanyDetailsView
